import gql from "graphql-tag";

export default gql`mutation RetryHolidayPayReversal($reason: String!, $reversalId: Int!) {
    retryHolidayPayReversal(reason: $reason, reversalId: $reversalId) {
      id
      createdAt
      updatedAt
      responseAt
      sentAt
      holidayWorkerId
      workerId
      holidayPayrollId
      holidayPaymentId
      paymentStatusId
      dcTransferId
      reversedDcTransferId
      dcCustomerNumber
      paymentProviderReferenceCode
      email
      amount
      errorCode
      errorDescription
      notes
    }
  }`;
